import React from 'react';
import InfoCard from '../../components/InfoCard'; 
import Styles from "./styles.module.scss";
import Table from '../../components/table';
import { useNavigate } from 'react-router-dom';
import FormHead from '../../components/headings/FromHead';


function SubmittedCandidates(props: any) {

  const navigate = useNavigate()

  return (
    <section className="infoCardGrid">
      <InfoCard title="">
        <div className={Styles.infoCardhead}>
        <FormHead>Submitted Candidates</FormHead>
       {/*eslint-disable-next-line jsx-a11y/anchor-is-valid */}
       <a onClick={() => navigate('/resources')} >View All</a>
        </div>
        <Table type={"submittedCandidates"} data={props.data} />
        </InfoCard>
    </section>
  )
}

export default SubmittedCandidates